// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_6CR","cls2":"PaperClaiming-cls2_dvy PaperClaiming-cls1_6CR"};